<template>
  <Select
    :items="arrayPerPage"
    :selectedItem="filter.perPage"
    :label="filtro.name"
    :searchPlaceholder="$i18n('interface.novo_filtro.buscar_registros_por_pagina')"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :filtro_default="filtro.default"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        perPage: {
          id: '',
          name: '',
        },
      },
      arrayPerPage: [
        { id: '10', name: '10' },
        { id: '20', name: '20' },
        { id: '50', name: '50' },
        { id: '500', name: '500' },
      ],
    };
  },
  methods: {
    atualizar(perPage) {
      this.filter.perPage = perPage;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.perPage.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.perPage.id
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.arrayPerPage, this.filter.perPage);
  },
}
</script>
